<template>
  <div>
    <div v-for="note in sortedNotes" :key="note.Id">
      <note @editNote="onEditNote" @deleteNote="$emit('deleteNote', note)" :note="note"/>
    </div>
    <el-input type="textarea" v-model="newNote" placeholder="Add a new note..."></el-input>
    <el-button round size="small" @click="addNote" :disabled="newNote.length ===0">Save Note</el-button>
  </div>
</template>

<script>
import Note from '@/components/contacts/Note'

export default {
  props: ['notes'],
  data() {
    return {
      newNote: ''
    }
  },
  computed: {
    sortedNotes() {
      return this.notes
        .slice()
        .sort((a, b) => a.DateCreated.localeCompare(b.DateCreated))
    }
  },
  methods: {
    addNote() {
      this.$emit('addNote', this.newNote)
      this.newNote = ''
    },
    onEditNote(note) {
      this.$emit('editNote', note)
    }
  },
  components: {
    Note
  }
}
</script>
